angular.module("app").controller("PagesCreateItemPageController", [
    '$scope',
    'pagesService',
    'pageStatuses',
    'logger',
    'errorHandler',
    '$stateParams',
    'cropperService',
    'preloadedPageData',
    'userStorage',
    'categoryService',
    'aligns',
    'targets',
    'settingsService',
    function ($scope, pagesService, pageStatuses, logger, errorHandler, $stateParams, cropperService, preloadedPageData, userStorage, categoryService, aligns, targets, settingsService) {
        var settings = settingsService.getSettings(),
            init;


        $scope.userData = userStorage.getUserData();
        $scope.actualPageNames = angular.copy(preloadedPageData.names) || null;
        $scope.aligns = aligns;
        $scope.targets = targets;

        (init = function () {
            $scope.pageData = {
                status: pageStatuses[0],
                lang: preloadedPageData.page.lang,
                type: preloadedPageData.page.type,
                align: aligns[0],
                target: targets[0],
                name: ($scope.actualPageNames && $scope.actualPageNames[0]) ? $scope.actualPageNames[0].name : ""
            };
            $scope.categoryOptions = {
                page_id: "",
                categories: []
            };
            $scope.vm = {
                dateTimeFrom: "",
                dateTimeTo: ""
            };
            $scope.optionalSettings = {
                hideLanguages: true
            };
            $scope.globalOptions = {
                isGlobalActionsAllowed: settings.allowGlobalActions
            };
            $scope.pageStatuses = pageStatuses;
            $scope.page = angular.copy(preloadedPageData.page);
            $scope.page.type === 'news' && $scope.page.setActualBlock && ($scope.pageData.actual = true);
            $scope.draggedImage = "";
            $scope.draggedImageDataUrl = "";
            $scope.imageToLoad = undefined;
        })();

        $scope.tagsOptions = {
            allTags: [],
            tags: []
        };


        if ($scope.pageData.type == "news") {
            pagesService.getCategories({lang : $scope.pageData.lang, type: "category"}).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.allCategories = angular.copy(response.pages);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            );

            settings.allowGlobalActions && categoryService.getTags({page_id: $scope.page.id}).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.tagsOptions.allTags = angular.copy(response.items);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        $scope.submitEditPageItemForm = function () {
            $scope.preview(function (dataUrl) {
                delete $scope.pageData.forceTOChange;
                var requestObj = {
                    item: $scope.pageData
                };
                requestObj.item.page_id = $stateParams.pageId;
                requestObj.item.categories = getSelectedCategories(angular.copy($scope.categoryOptions.categories));
                requestObj.item.tags = getSelectedCategories(angular.copy($scope.tagsOptions.tags));

                if(dataUrl != $scope.draggedImageDataUrl) {
                    requestObj.item.image = dataUrl;
                }

                if (!!$scope.imageToLoad && !!$scope.imageToLoad.fileUrl) {
                    delete requestObj.item.image;
                    requestObj.item.media_id = $scope.imageToLoad.id
                }

                !requestObj.item.global && (delete requestObj.item.global);

                if ($scope.pageData.type == "sidebar" || $scope.page.type == "text" || $scope.pageData.type == "news") {
                    !!$scope.vm.fromDate && (requestObj.item.start_date = $scope.vm.fromDate);
                    !!$scope.vm.toDate && (requestObj.item.end_date = $scope.vm.toDate);
                }

                if ($scope.page.type != "category" &&  $scope.page.type != "text") {
                    delete requestObj.item.name
                }

                if ($scope.page.type != "sidebar") {
                    delete requestObj.item.action;
                    delete requestObj.item.align;
                    delete requestObj.item.video_link;
                    delete requestObj.item.linktarget
                }

                pagesService.createPageItem(requestObj).then(
                    function (response) {
                        if (response.status == "ok") {
                            logger.logSuccess('global.saved');
                            init();
                            $scope.edit_page_item_form && $scope.edit_page_item_form.$setPristine();
                            $scope.tagsOptions.tags = [];
                            $scope.$emit("force:reset:editor");
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            });
        };

        $scope.handleChangeOfCategory = function (pageId) {
            pagesService.groupCategory({page_id: pageId, count: "all"}).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.categoryItems = angular.copy(response.items);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
            if (this.from) {
                $scope.vm.dateTimeFrom = dateTime;
                $scope.vm.fromDate = dateToSave || undefined;
                $scope.pageData.start_date = $scope.vm.fromDate;
            } else {
                $scope.vm.dateTimeTo = dateTime;
                $scope.vm.toDate = dateToSave || undefined;
                $scope.pageData.end_date = $scope.vm.toDate;
            }
        };

        cropperService.call($scope);

        $scope.onCategoryItemSelect
            = $scope.onCategoryItemDeselect
            = $scope.onCategorySelectAll
            = $scope.onCategoryUnselectAll
            = $scope.onTagsItemSelect
            = $scope.onTagsItemDeselect
            = $scope.onTagsSelectAll
            = $scope.onTagsUnselectAll
            = angular.noop;

        function getSelectedCategories (categories) {
            var returnArray = [],
                index = 0;

            while(categories[index]) {
                returnArray.push(categories[index].id);
                index++
            }
            return returnArray
        }
    }
]);